import script from "./PonModule.vue?vue&type=script&setup=true&lang=js"
export * from "./PonModule.vue?vue&type=script&setup=true&lang=js"

import "./PonModule.vue?vue&type=style&index=0&id=66da3fa6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66da3fa6"]])

export default __exports__